import React, { useState, useEffect, useContext } from 'react';
import '../pages/Profile.css';
import { InputContext } from '../components/InputContext'; 

const baseURL = process.env.REACT_APP_API_URL;

const Bio = ({ username, canEdit = false }) => {
  const { username: currentUser } = useContext(InputContext);
  const [bio, setBio] = useState("Nothing to see here!");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!username) return;

    fetch(`${baseURL}/user/${username}`)
      .then(res => res.json())
      .then(data => {
        if (data.bio) setBio(data.bio);
      });
  }, [username]);

  const handleSave = async () => {
    setIsEditing(false);
    try {
      await fetch(`${baseURL}/acc/user/${username}/bio`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bio })
      });
    } catch (err) {
      console.error('Failed to save bio', err);
    }
  };

  return (
    <div className="bio-box">
      <strong>Bio</strong><br />
      {isEditing ? (
        <>
          <textarea
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            className="bio-textarea"
          />
          <button onClick={handleSave} className="bio-button">Save</button>
        </>
      ) : (
        <>
          <p>{bio.split('\n').map((line, i) => <span key={i}>{line}<br /></span>)}</p>
          {canEdit && currentUser === username && (
            <button onClick={() => setIsEditing(true)} className="bio-button">Edit</button>
          )}
        </>
      )}
    </div>
  );
};

export default Bio;
